export const environment = {
  base_url: 'https://test.conhector.fundak.io/backend_staging',
  baseUploads: 'https://test.conhector.fundak.io/backend_staging/uploads/',
};
